import ServicesListContainer from './ServicesListContainer';

export default ServicesListContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/ServicesList/index.js